/* ============================================================
   DJN About Page — Scroll Reveal JS
   File: assets/djn-about.js
   Scope: IntersectionObserver, prefers-reduced-motion safe
   ============================================================ */

(function () {
  'use strict';

  const THRESHOLD = 0.15;
  const ROOT_MARGIN = '0px 0px -60px 0px';

  function initReveal() {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced) {
      document.querySelectorAll('.djn-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.djn-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          const el = entry.target;
          const delay = parseInt(el.dataset.delay || '0', 10);

          if (delay > 0) {
            setTimeout(function () {
              el.classList.add('is-visible');
            }, delay);
          } else {
            el.classList.add('is-visible');
          }

          observer.unobserve(el);
        });
      },
      {
        threshold: THRESHOLD,
        rootMargin: ROOT_MARGIN
      }
    );

    document.querySelectorAll('.djn-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();
